module.exports = __webpack_public_path__ + "img/check-list-active.3c575e6f.svg";